import React from "react";

import { ArrowLeftIcon as ArrowLeft } from "@packages/ds";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";

import { APP_NAME } from "Constants/documentationUrls";
import { Link } from "ds/Button";
import useDecodedParams from "Hooks/useDecodedParams";
import { prevWizardStep } from "Reducers/project/wizard";
import { subscriptionSelector } from "Reducers/subscription";

import ListSteps from "../ListSteps";

import * as S from "./Outro.styles";

const Outro = ({ project }) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const { organizationId, projectId } = useDecodedParams();

  const subscription = useSelector(state => {
    return subscriptionSelector(state, {
      organizationId,
      projectId,
      id: project?.getSubscriptionId()
    });
  });

  const prevStep = e => {
    e?.preventDefault();
    dispatch(prevWizardStep({ organizationId, projectId }));
  };

  return (
    <S.Wrapper>
      <S.Content>
        <S.ImageContainer />
        <S.ProjectTitle tag="h2">
          {intl.formatMessage({ id: "wizard.outro.title.first_line" })}
        </S.ProjectTitle>
        <S.ProjectTitle tag="h2">
          {intl.formatMessage(
            { id: "wizard.outro.title.second_line" },
            {
              name: project?.title
            }
          )}
        </S.ProjectTitle>
        <S.ProjectTitle tag="h2">
          {intl.formatMessage(
            { id: "wizard.outro.title.third_line" },
            { app: APP_NAME }
          )}
        </S.ProjectTitle>
        <p>
          {intl.formatMessage(
            { id: "wizard.outro.sentence" },
            {
              plan: subscription?.plan,
              a: (...chunk) => (
                <Link to={`/${organizationId}/${projectId}/-/settings/domains`}>
                  {chunk}
                </Link>
              )
            }
          )}
        </p>
        <S.Footer>
          <S.FooterButton
            variant="link"
            onClick={prevStep}
            analyticId="back-link"
          >
            <ArrowLeft />
          </S.FooterButton>
          <S.Pipe />
          <Link
            href={intl.formatMessage({ id: "links.documentation" })}
            target="_blank"
            rel="noopener noreferrer"
            analyticId="wizard.outro.view_doc"
          >
            {intl.formatMessage({ id: "wizard.outro.view_doc" })}
          </Link>
        </S.Footer>
      </S.Content>

      <ListSteps />
    </S.Wrapper>
  );
};

Outro.propTypes = {
  project: PropTypes.object
};

export default Outro;
